import { render, staticRenderFns } from "./CreateASurvey.vue?vue&type=template&id=621ead3a&scoped=true"
import script from "./CreateASurvey.vue?vue&type=script&lang=js"
export * from "./CreateASurvey.vue?vue&type=script&lang=js"
import style0 from "./CreateASurvey.vue?vue&type=style&index=0&id=621ead3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621ead3a",
  null
  
)

export default component.exports